__turbopack_context__.v({
  "className": "montserrat_3c05d630-module__Ma_a1a__className",
});
